import React from 'react';
import { Container, Button } from '../design-system';
import { ArrowRight, MessageCircle } from 'lucide-react';

interface CTAProps {
  onContactClick: () => void;
}

export function CTA({ onContactClick }: CTAProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-indigo-600 to-purple-600 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      
      <Container maxWidth="xl">
        <div className="relative text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Pronto para transformar seu problema em solução?
          </h2>
          <p className="text-xl text-indigo-100 mb-10 max-w-3xl mx-auto">
            Conecte-se com nosso time e veja como transformamos problemas reais em soluções digitais, de forma organizada, objetiva e segura.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              variant="secondary"
              onClick={onContactClick}
            >
              <MessageCircle className="w-5 h-5" />
              Falar com Especialista
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-indigo-600"
            >
              Ver Casos de Sucesso
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>

        </div>
      </Container>
    </section>
  );
}
